const BUTTONS = {
  decided: {
    content: "buyerPortal.roomBook.cardActions.decided",
    icon: "checkmark",
    size: "huge",
    fluid: true,
    primary: true
  },
  undecided: {
    content: "buyerPortal.roomBook.cardActions.undecided",
    icon: "cogs",
    size: "huge",
    fluid: true,
    basic: true
  },
  warning: {
    content: "buyerPortal.roomBook.cardActions.warning",
    icon: "exclamation triangle",
    size: "huge",
    fluid: true,
    className: "warning"
  },
  disabled: {
    content: "buyerPortal.roomBook.cardActions.disabled",
    icon: "ban",
    size: "huge",
    fluid: true,
    disabled: true
  },
  buyable: {
    content: "buyerPortal.roomBook.cardActions.buyable",
    icon: "cart plus",
    size: "huge",
    fluid: true,
    basic: true
  },
  replacement: {
    content: "buyerPortal.roomBook.cardActions.replacement",
    icon: "cart plus",
    size: "huge",
    fluid: true,
    basic: true
  },
  mandatory: {
    content: undefined, // will hide the button
    icon: "lock",
    size: "huge",
    fluid: true,
    basic: true,
    disabled: true
  }
};

const getMode = item => {
  if (item.isMandatoryDisplay) {
    return "mandatory";
  }

  if (item.isOptional) {
    if (!item.isActivated && !item.isBackendActivated) {
      if (item.isReplacement) {
        return "replacement";
      }
      return "buyable";
    }
  }
  if (item.isValid) {
    if (item.isConfigurable) {
      if (item.isDecided) {
        return "decided";
      }
      return "undecided";
    }
    return "disabled";
  }
  return "warning";
};

export const navigationButton = item => {
  return BUTTONS[getMode(item)];
};
